export const publicKey = "Vd0uBZUrdz8Rq0QhU";
export const serviceId = "service_sc3o76f";
export const templateId = "template_p70cmer";
export const siteKey = "6LfC6qIlAAAAANjBcYbH0lsOXYS5-zIMkkedYXcR"